import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';

import { Link } from '@lanl-web/lanl-components';

import './ImageLink.scss';

export const ImageLink = ({ className, imgURL, link, title }) => {
  const classes = classNames('image-link', className);

  return (
    <div className={classes}>
      <div className='image' style={{ backgroundImage: `url(${imgURL})` }} />
      <div className='story-body'>
        <h3 className='title'>{title}</h3>
        <Link href={link}>
          Learn More
          <span className='sr-only'>about the article: {title}</span>
        </Link>
      </div>
    </div>
  );
};

ImageLink.defaultProps = {};

ImageLink.propTypes = {
  imgURL: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default ImageLink;

export const fragBoxImageLink = graphql`
  fragment boxImageLink on DirectusData_rl_components {
    image_link {
      image_link {
        title
        image {
          filename_disk
        }
        url {
          external
          page {
            slug
            parent {
              slug
              parent {
                slug
                parent {
                  slug
                }
              }
            }
          }
          project {
            slug
          }
        }
      }
    }
  }
`;
